import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChannelsComponent } from './channels.component';
import { ChannelFormComponent } from './components/channel-form/channel-form.component';
import { ChannelItemComponent } from './components/channel-item/channel-item.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatProgressSpinnerModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [ChannelsComponent, ChannelFormComponent, ChannelItemComponent],
})
export class ChannelsModule {}
